import {
  QUERY_BUILDER_REQUEST,
  QUERY_BUILDER_SUCCESS,
  QUERY_BUILDER_FAILURE,
  QUERY_BUILDER_SEARCH_REQUEST,
  QUERY_BUILDER_SEARCH_SUCCESS,
  QUERY_BUILDER_SEARCH_FAILURE,
  QUERY_BUILDER_QUERIES_REQUEST,
  QUERY_BUILDER_QUERIES_SUCCESS,
  QUERY_BUILDER_QUERIES_FAILURE,
  QUERY_BUILDER_ADD_QUERY_REQUEST,
  QUERY_BUILDER_ADD_QUERY_SUCCESS,
  QUERY_BUILDER_ADD_QUERY_FAILURE,
  QUERY_BUILDER_DELETE_QUERY_REQUEST,
  QUERY_BUILDER_DELETE_QUERY_SUCCESS,
  QUERY_BUILDER_DELETE_QUERY_FAILURE
} from './QueryBuilderActions';

const initialState = {
  data: null,
  error: null,
  isLoading: false,
  result: null,
  isSearching: false,
  queries: null,
  isQueriesLoading: false,
  isQueryAdding: false,
  isQueryDeleting: false,
};

export default function queryBuilderReducer(
  state = initialState,
  { type, payload },
) {
  switch (type) {
    case QUERY_BUILDER_REQUEST:
      return { ...state, isLoading: true };
    case QUERY_BUILDER_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false };
    case QUERY_BUILDER_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case QUERY_BUILDER_SEARCH_REQUEST:
      return { ...state, isSearching: true };
    case QUERY_BUILDER_SEARCH_SUCCESS:
      return { ...state, result: payload.data, error: null, isSearching: false };
    case QUERY_BUILDER_SEARCH_FAILURE:
      return { ...state, error: payload.error, isSearching: false };

    case QUERY_BUILDER_QUERIES_REQUEST:
      return { ...state, isQueriesLoading: true };
    case QUERY_BUILDER_QUERIES_SUCCESS:
      return { ...state, queries: payload.data, error: null, isQueriesLoading: false };
    case QUERY_BUILDER_QUERIES_FAILURE:
      return { ...state, error: payload.error, isQueriesLoading: false };

    case QUERY_BUILDER_ADD_QUERY_REQUEST:
      return { ...state, isQueryAdding: true };
    case QUERY_BUILDER_ADD_QUERY_SUCCESS:
      return { ...state, error: null, isQueryAdding: false };
    case QUERY_BUILDER_ADD_QUERY_FAILURE:
      return { ...state, error: payload.error, isQueryAdding: false };

    case QUERY_BUILDER_DELETE_QUERY_REQUEST:
      return { ...state, isQueryDeleting: true };
    case QUERY_BUILDER_DELETE_QUERY_SUCCESS:
      return { ...state, error: null, isQueryDeleting: false };
    case QUERY_BUILDER_DELETE_QUERY_FAILURE:
      return { ...state, error: payload.error, isQueryDeleting: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/query-builder/QueryBuilderReducer.js